import React from 'react';
import type { CheckboxProps } from './Checkbox.props';
import IcCheckBoxSelected from './assets/IcCheckboxSelected.svg';
import IcCheckBox from './assets/IcCheckBox.svg';


import styled from 'styled-components';
import Text from 'components/Text';

const Checkbox = ({ value, onChange, label, size = 24, disabled, style, className }: CheckboxProps) => {

  const handleToggle = () => {
    if (!disabled) {
      onChange?.(!value);
    }
  };

  return (
    <Container onClick={handleToggle} style={style} className={className} type='button'>
      <WrapperIcon  disabled={disabled}>
        {value ? <img src={IcCheckBoxSelected} width={size} height={size} alt='checked' /> : <img src={IcCheckBox} width={size} height={size} alt='unchecked' />}
      </WrapperIcon>

      {label && (
        <Text variant='CONTENT_1' weight='medium' className='styled-text' color={disabled ? 'text_3' : 'text_3'} textAlign='left'>
          {label}
        </Text>
      )}
    </Container>
  );
};

export default Checkbox;

const WrapperIcon = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ disabled }) => disabled && `
    cursor: not-allowed;
    opacity: 0.6;
  `}
`;

const Container = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Mona Sans', sans-serif;
`;
